import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import {
  Card,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import { OccupancyData } from '@/routes/(app)/(scenarios)/types';
import { deriveScenarioCardStats } from '@/routes/(app)/(scenarios)/utils/scenario.utils';

interface ScenarioCardsProps {
  data: OccupancyData;
}
export const ScenarioCards: FC<ScenarioCardsProps> = ({ data }) => {
  const { t } = useTranslation();
  const stats = useMemo(() => deriveScenarioCardStats(data.runs), [data.runs]);

  return (
    <div className='grid grid-cols-5 gap-4'>
      <Card className='@container/card'>
        <CardHeader>
          <CardDescription>
            {t('scenario.stats.maxRegularOccupancy')}
          </CardDescription>
          <CardTitle className='text-2xl font-semibold tabular-nums @[250px]/card:text-3xl'>
            {Math.round(stats.maxRegularOccupancy)}%
          </CardTitle>
        </CardHeader>
        <CardFooter className='flex-col items-start gap-1.5 text-sm'>
          <div className='text-muted-foreground'>
            {t('scenario.stats.maxRegularOccupancyDescription')}
          </div>
        </CardFooter>
      </Card>
      <Card className='@container/card'>
        <CardHeader>
          <CardDescription>
            {t('scenario.stats.maxReeferOccupancy')}
          </CardDescription>
          <CardTitle className='text-2xl font-semibold tabular-nums @[250px]/card:text-3xl'>
            {Math.round(stats.maxReeferOccupancy)}%
          </CardTitle>
        </CardHeader>
        <CardFooter className='flex-col items-start gap-1.5 text-sm'>
          <div className='text-muted-foreground'>
            {t('scenario.stats.maxReeferOccupancyDescription')}
          </div>
        </CardFooter>
      </Card>
      <Card>
        <CardHeader>
          <CardDescription>
            {t('scenario.stats.amountOfSimulations')}
          </CardDescription>
          <CardTitle className='text-2xl font-semibold tabular-nums @[250px]/card:text-3xl'>
            {stats.amountOfSimulations}
          </CardTitle>
        </CardHeader>
        <CardFooter className='flex-col items-start gap-1.5 text-sm'>
          <div className='text-muted-foreground'>
            {t('scenario.stats.amountOfSimulationsDescription')}
          </div>
        </CardFooter>
      </Card>
    </div>
  );
};
